import { defineMessages } from 'react-intl';

export default defineMessages({
  exists: 'already exists',
  linkId: 'Category ID',
  name: 'Category Name',
  path: 'Category Path',
  title: 'Create New Category'
});
